module.exports = __webpack_public_path__ + "img/hipercard-v2.1599b13b.svg";